/**
 * Maps any persisted legacy body condition and activity level values to the new enum values (TECH-2892)
 */
import type { TSufActivityLevel, TSufBodyType } from "../types/enums";

export const LEGACY_BODY_TYPE_MAP: Record<string, TSufBodyType> = {
  SKINNY: "THIN",
  CHUBBY: "OVERWEIGHT",
  OBESE: "VERY_OVERWEIGHT",
};

export const LEGACY_ACTIVITY_LEVEL_MAP: Record<string, TSufActivityLevel> = {
  INACTIVE: "INDOOR_HIGH_ACTIVITY",
  ACTIVE: "INDOOR_AND_OUTDOOR",
  EXPLORER: "MOSTLY_OUTDOOR",
};

const isRecord = (value: unknown): value is Record<string, unknown> => (
  typeof value === "object" && value !== null && !Array.isArray(value)
);

const lookupLegacy = (
  value: unknown,
  map: Record<string, string>,
): string | undefined => (typeof value === "string" ? map[value] : undefined);

/**
 * Only known legacy names are remapped. Values already on the new scale are left alone.
 * Anything unrecognised (e.g. bad data) passes through this function and fails on parse.
 */
export const migrateLegacyCatFitness = (cat: unknown): unknown => {
  if (!isRecord(cat) || !isRecord(cat["body"])) {
    return cat;
  }

  const body = cat["body"];
  const bodyType = lookupLegacy(body["bodyType"], LEGACY_BODY_TYPE_MAP);
  const activityLevel = lookupLegacy(body["activityLevel"], LEGACY_ACTIVITY_LEVEL_MAP);

  if (!bodyType && !activityLevel) {
    return cat;
  }

  return {
    ...cat,
    body: {
      ...body,
      ...(bodyType ? { bodyType } : {}),
      ...(activityLevel ? { activityLevel } : {}),
    },
  };
};
